<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="110px">
        <el-form-item label="信息类型">
          <el-select v-model="editData.infotype" placeholder="请选择" class="select">
            <el-option
              v-for="item in infotypeList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="标题" class="addAdminForm">
            <el-input v-model="editData.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="图片链接" class="addAdminForm">
            <el-input v-model="editData.picurl" placeholder="请输入图片链接"></el-input>
          </el-form-item>
          <el-form-item label="视频链接" class="addAdminForm">
            <el-input v-model="editData.videourl" placeholder="请输入视频链接"></el-input>
          </el-form-item>
          <el-form-item label="内容">
            <VueUeditorWrap v-model="editData.content" :config="myConfig"></VueUeditorWrap>
          </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      infotypeList: [],
      editData: {
        id: '0',
        infotype: '',
        title: '',
        content: '',
        picurl: '',
        videourl: ''
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  mounted () {
    this.infotypeList = Vue.prototype.FunGetInfoType()
  },
  methods: {
    LoadData (row) {
      this.editData.id = row.Id
      this.editData.infotype = row.Infotype.toString()
      this.editData.title = row.Title
      this.editData.content = row.Content
      this.editData.picurl = row.Picurl
      this.editData.videourl = row.Videourl
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditKgjtWebsiteGeneralInformation()
    },
    EditKgjtWebsiteGeneralInformation: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        infotype: that.editData.infotype,
        title: that.editData.title,
        content: that.editData.content,
        picurl: that.editData.picurl,
        videourl: that.editData.videourl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteGeneralInformation, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
